(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7887],{

/***/ 6013:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/rooms",
      function () {
        return __webpack_require__(9988);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeroV2; }
/* harmony export */ });
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(870);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_effect_creative__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9180);
/* harmony import */ var swiper_css_effect_creative__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_creative__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8352);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7239);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9735);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9741);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}














function HeroV2(param1) {
    var heroItem = param1.heroItem, _hasFormNow = param1.hasFormNow, hasFormNow = _hasFormNow === void 0 ? false : _hasFormNow, height = param1.height;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(), query = ref.query, isReady = ref.isReady;
    var bulletsRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var isLarge = (0,_utils_mediaQuery__WEBPACK_IMPORTED_MODULE_13__/* .useLargeQuery */ .fc)().isLarge;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), sliderCaptions = ref1[0], setSliderCaptions = ref1[1];
    var id1 = heroItem.id, name = heroItem.name, banner = heroItem.banner, color_primary = heroItem.color_primary, hotel_code = heroItem.hotel_code, slider = heroItem.slider, is_parador = heroItem.is_parador, has_banner = heroItem.has_banner;
    var BannerHeading = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q;
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        function f() {
            return _f.apply(this, arguments);
        }
        function _f() {
            _f = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1() {
                var temp;
                return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            _ctx1.next = 2;
                            return Promise.all(slider.map(function() {
                                var _ref = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
                                    var id, x, y;
                                    return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                id = param.id;
                                                _ctx.next = 3;
                                                return (0,_utils_api__WEBPACK_IMPORTED_MODULE_11__/* .getWPImage */ .Mu)(id);
                                            case 3:
                                                x = _ctx.sent;
                                                _ctx.next = 6;
                                                return x.data.caption;
                                            case 6:
                                                y = _ctx.sent;
                                                if (y) {
                                                    y = y.rendered.replace("<p>", "").replace("</p>\n", "");
                                                }
                                                return _ctx.abrupt("return", y);
                                            case 9:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }()));
                        case 2:
                            temp = _ctx1.sent;
                            setSliderCaptions(temp);
                        case 4:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1);
            }));
            return _f.apply(this, arguments);
        }
        f();
    }, [
        isReady
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
        className: "hero-container-v2",
        ref: containerRef,
        h: "800px",
        maxH: "800px",
        children: [
            !is_parador || has_banner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BannerHeading, {
                className: "banner",
                as: "h1",
                size: "lg",
                fontWeight: 300,
                letterSpacing: "widestx",
                textAlign: "center",
                children: banner
            }) : null,
            slider && slider.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_10__/* .Swiper */ .tq, {
                lazy: true,
                centeredSlides: true,
                speed: 1000,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
                loop: slider.length > 1,
                pagination: {
                    clickable: true
                },
                navigation: true,
                modules: slider.length > 1 ? [
                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt,
                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Pagination */ .tl,
                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Navigation */ .W_
                ] : [],
                className: "mySwiper",
                onInit: function(swiper) {
                    if (slider.length > 1) {
                        swiper.navigation.init();
                        swiper.navigation.update();
                    }
                },
                children: slider && slider.map(function(image, i) {
                    var _i;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_10__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                            className: "image-container",
                            h: "800px",
                            width: "100%",
                            children: [
                                !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(sliderCaptions[i]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                    className: "slider-caption",
                                    zIndex: 9,
                                    position: "absolute",
                                    fontWeight: 500,
                                    fontSize: [
                                        "x-small",
                                        "small"
                                    ],
                                    bottom: [
                                        "2px",
                                        "24px"
                                    ],
                                    opacity: [
                                        0.5,
                                        1
                                    ],
                                    right: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_13__/* .safeMarginX */ .Mp,
                                    color: "white",
                                    children: (_i = sliderCaptions[i]) !== null && _i !== void 0 ? _i : ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    h: "100%",
                                    w: "100%",
                                    bg: is_parador && hasFormNow ? "blackAlpha.400" : "blackAlpha.700",
                                    zIndex: 5
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    className: "image-slider",
                                    src: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_12__/* .convertImgHttps */ .Nu)(image.url),
                                    alt: "".concat(name, " slide ").concat(i + 1),
                                    layout: "fill",
                                    sizes: "(max-width: 640px) 100vw, (max-width: 1200px) 100vw, 100vw",
                                    priority: i === 0,
                                    quality: i === 0 ? 85 : 75,
                                    objectFit: "cover",
                                    loading: i === 0 ? "eager" : "lazy",
                                    unoptimized: true
                                })
                            ]
                        })
                    }, i);
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                h: "800px",
                bg: "gray.400"
            })
        ]
    });
};


/***/ }),

/***/ 9988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Room; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var _components_HeroV2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2699);
/* harmony import */ var _components_SectionView__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(570);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9536);
/* harmony import */ var _layout_FooterHotel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8078);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4850);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1127);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9741);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var __N_SSG = true;
function Room(param1) {
    var header = param1.header, hotelBrands = param1.hotelBrands, roomsHome = param1.roomsHome, hero = param1.hero;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), headerHeight1 = ref[0], setHeaderHeight = ref[1];
    var ref1 = _slicedToArray((0,_utils_hooks__WEBPACK_IMPORTED_MODULE_10__/* .useFetchSWRv2 */ .bX)("rooms", {
        hotel_name: roomsHome.name,
        cct_status: "publish",
        _orderby: "start_from",
        _order: "asc"
    }), 3), rooms = ref1[0], isLoading = ref1[1], isError = ref1[2];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                title: "Rooms - ".concat(roomsHome.name, " | Parador Hotels & Resorts"),
                description: roomsHome.room_subheadline,
                image: hero.slider[0].url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: true,
                getHeight: function(headerHeight) {
                    return setHeaderHeight(headerHeight);
                },
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HeroV2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                hasFormNow: true,
                heroItem: hero,
                height: "calc(100vh - ".concat(headerHeight1, "px)")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                p: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_11__/* .safeMarginDesc */ .nb,
                flexDirection: "column",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                    as: "h2",
                    maxW: {
                        base: "90%",
                        md: "70%"
                    },
                    textAlign: "center",
                    fontSize: [
                        "xl",
                        "2xl",
                        "3xl"
                    ],
                    fontWeight: 400,
                    letterSpacing: "widest",
                    children: roomsHome.room_subheadline
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                px: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_11__/* .safeMarginX */ .Mp,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .izJ, {
                    orientation: "horizontal",
                    borderColor: "blackAlpha.400"
                })
            }),
            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                h: "50vh",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Spinner */ .$jN, {
                    size: "xl"
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionView__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                type: "rooms",
                title: locale == "id" ? "Kamar" : "Rooms",
                color: roomsHome.color_primary,
                items: rooms ? rooms.map(function(param) {
                    var _ID = param._ID, name = param.name, thumbnail = param.thumbnail, desc_short_id = param.desc_short_id, desc_short_en = param.desc_short_en, bed_type = param.bed_type, room_size = param.room_size, start_from = param.start_from, total_guest = param.total_guest, room_name_id = param.room_name_id, room_size_manual = param.room_size_manual;
                    return {
                        thumb: thumbnail,
                        _ID: _ID,
                        desc: locale == "id" ? desc_short_id : desc_short_en,
                        title: locale == "id" && !(0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(room_name_id) ? room_name_id : name,
                        bed_type: bed_type,
                        room_size: (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(room_size_manual) ? room_size : room_size_manual,
                        start_from: start_from,
                        total_guest: total_guest
                    };
                }) : [],
                targetItems: rooms ? rooms.map(function(param) {
                    var _ID = param._ID;
                    return "/".concat(roomsHome.slug, "/rooms/").concat(_ID);
                }) : []
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                w: 20
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_FooterHotel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                instagram: header.instagram,
                facebook: header.facebook,
                locationLink: header.location_url,
                location: header.location_long,
                email: header.email,
                phone: header.phone,
                bg: roomsHome.color_primary,
                color: "white",
                logo: roomsHome.logo_light,
                hotelSlug: roomsHome.slug
            })
        ]
    });
};


/***/ }),

/***/ 7239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jp": function() { return /* binding */ getCountryList; },
  "Ne": function() { return /* binding */ getOneOrder; },
  "Jv": function() { return /* binding */ getSigMatch; },
  "Mc": function() { return /* binding */ getSpecialOffer; },
  "oW": function() { return /* binding */ getWPDining; },
  "Mu": function() { return /* binding */ getWPImage; },
  "ts": function() { return /* binding */ postAccount; },
  "ay": function() { return /* binding */ postCapthca; },
  "w1": function() { return /* binding */ postCheckCoupon; },
  "$8": function() { return /* binding */ postMeetingEnquiry; },
  "lB": function() { return /* binding */ postMessages; },
  "mv": function() { return /* binding */ postOrder; },
  "GK": function() { return /* binding */ postOrderLater; },
  "D0": function() { return /* binding */ postRDPnotify; },
  "ZC": function() { return /* binding */ postSendMail; },
  "AQ": function() { return /* binding */ postWeddingEnquiry; }
});

// UNUSED EXPORTS: getBlogDetail, getDining, getFaq, getHotelBrands, getHotelDetail, getHotelNavBrands, getRoomDetail, getSitemap, getSliderSpecialOffer

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/utils/apiCache.ts
var cache = new Map();
function getCacheKey(endpoint) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var paramStr = JSON.stringify(params);
    return "".concat(endpoint, ":").concat(paramStr);
}
function getCachedData(key) {
    var entry = cache.get(key);
    if (!entry) return null;
    var now = Date.now();
    var isExpired = now - entry.timestamp > entry.ttl;
    if (isExpired) {
        cache.delete(key);
        return null;
    }
    return entry.data;
}
function setCachedData(key, data) {
    var ttlSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3600;
    cache.set(key, {
        data: data,
        timestamp: Date.now(),
        ttl: ttlSeconds * 1000
    });
}
function clearCache() {
    cache.clear();
}
function getCacheStats() {
    return {
        size: cache.size,
        entries: Array.from(cache.keys())
    };
}

;// CONCATENATED MODULE: ./src/utils/api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//wordpress endpoint
var getHotelDetail = function(params) {
    return functions/* fetcher.get */._i.get("/hotels/", {
        params: params
    });
};
var getRoomDetail = function(params) {
    return fetcher.get("/rooms/", {
        params: params
    });
};
var getBlogDetail = function(params) {
    return fetcher.get("/blog/", {
        params: params
    });
};
var getSitemap = function(params) {
    return fetcher.get("/sitemap/", {
        params: params
    });
};
var getSpecialOffer = function(params) {
    return functions/* fetcher.get */._i.get("/special_offers/", {
        params: params
    });
};
var getWPDining = function(params) {
    return functions/* fetcher.get */._i.get("/dining/?", {
        params: params
    });
};
var getFaq = function(params) {
    return fetcher.get("/faq/", {
        params: params
    });
};
//nextjs endpoint
var getCountryList = function(params) {
    return functions/* fetcherNext.get */.mj.get("/country-list/?", {
        params: params
    });
};
var getDining = function(params) {
    return fetcherNext.get("/dining-nav/?", {
        params: params
    });
};
var getSliderSpecialOffer = function(params) {
    return fetcherNext.get("/special-offer-slider/?", {
        params: params
    });
};
var getHotelNavBrands = function(params) {
    return fetcherNext.get("/hotel-nav-brands/?", {
        params: params
    });
};
var getHotelBrands = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(params) {
        var cacheKey, cached, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = getCacheKey("getHotelBrands", params);
                    cached = getCachedData(cacheKey);
                    if (!cached) {
                        _ctx.next = 5;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", cached);
                case 5:
                    ;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return Promise.all([
                        getHotelDetail({
                            brand: "Atria Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Atria residences",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria residences", r.data);
                        }),
                        getHotelDetail({
                            brand: "Starlet Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Starlet Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Vega Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Vega Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Fame Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Fame Hotel", r.data);
                        }), 
                    ]);
                case 9:
                    result = _ctx.sent;
                    // Cache the result for 1 hour
                    setCachedData(cacheKey, result, 3600);
                    return _ctx.abrupt("return", result);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](6);
                    ;
                    throw _ctx.t0;
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                14
            ]
        ]);
    }));
    return function getHotelBrands(params) {
        return _ref.apply(this, arguments);
    };
}();
var postMessages = function(body) {
    return functions/* fetcher.post */._i.post("/messages/", body);
};
var postMeetingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/meeting_enquiry/", body);
};
var postWeddingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/wedding_enquiry/", body);
};
var postAccount = function(body) {
    return functions/* fetcher.post */._i.post("/accounts/", body);
};
var postOrder = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-now?user=guest", body);
};
var getSigMatch = function(params) {
    return functions/* fetcherNext.get */.mj.get("/is-paid/?", {
        params: params
    });
};
var getOneOrder = function(params) {
    return functions/* fetcherNext.get */.mj.get("/check-order/?", {
        params: params
    });
};
var postOrderLater = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-later", body);
};
var postRDPnotify = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-rdp", body);
};
var postCapthca = function(body) {
    return functions/* fetcherNext.post */.mj.post("/captcha", body);
};
var postCheckCoupon = function(body) {
    return functions/* fetcherNext.post */.mj.post("/coupon-check?user=guest", body);
};
var getWPImage = function(id) {
    return functions/* fetcherWPImage.get */.ON.get("/".concat(id));
};
var postSendMail = function(body) {
    return functions/* fetcherNext.post */.mj.post("/mail?user=guest", body);
};


/***/ }),

/***/ 9180:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,6394,4939,8078,570,9774,2888,179], function() { return __webpack_exec__(6013); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);